module.exports = __webpack_public_path__ + "media/images/icons/calendar-2340b3a2674dbc24a716481faaca7d04.svg";